import { createPublicClient, http } from 'viem'

import { l1NativeWagmiConfig } from '@/plugins/auth/config'

export interface VerifySignature {
  address: `0x${string}` | ''
  message: string
  signHash: `0x${string}` | ''
}

const publicViemClient = createPublicClient({
  chain: l1NativeWagmiConfig,
  transport: http(),
})

export default publicViemClient
